import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { ENUM__field_connectable_type } from '../../_base/_methods/ENUM__field_connectable_type';
import { DTO_META__field_info } from '../../_base/DTO_META__field_info';
import { DECORATOR__class_serialization_tested } from '../_base/DECORATOR__class_serialization_tested';
import { DECORATOR__class_serialization_tested_for_hash } from '../_base/DECORATOR__class_serialization_tested_for_hash';
import { FIELD_PRIMITIVE__base_string } from './FIELD_PRIMITIVE__base_string';

@DECORATOR__class_serialization_tested
@DECORATOR__class_serialization_tested_for_hash
export class FIELD_PRIMITIVE__string_enum extends FIELD_PRIMITIVE__base_string {
  /*
   * STATIC FIELDS
   */

  static _class_name_static = ENUM__dto_class_name.GRAPH_FIELD_PRIMITIVE_STRING_ENUM;

  /*
   * VALUE REGISTER INPUT
   */

  /*
   * ENUM CREATE DEFAULT
   */

  static create_default__enum<T extends Record<string, string>, V = T[keyof T]>(value: V, enum_object: T): Partial<FIELD_PRIMITIVE__base_string> {
    assert_type_enum(value, enum_object);

    let values_allowed = Object.values(enum_object);
    let value_range = values_allowed;

    return { value, values_allowed, value_range };
  }

  static create_default__enum_value(value: string): Partial<FIELD_PRIMITIVE__base_string> {
    return { value };
  }

  static create_default__enum_object<T extends Record<string, string>>(enum_object: T): Partial<FIELD_PRIMITIVE__base_string> {
    let values_allowed = Object.values(enum_object);
    let value_range = values_allowed;

    let out = { values_allowed, is_empty_allowed: false, value_range };

    return out;
  }

  /*
   * ENUM REGISTER INPUT
   */
  static register_input__enum_object<T extends Record<string, string>>(enum_object: T, options_meta: Partial<DTO_META__field_info> = {}) {
    return this.init_as_input(this.create_default__enum_object(enum_object), options_meta);
  }

  static register_input__enum<T extends Record<string, string>, V = T[keyof T]>(value: V, enum_object: T, options_meta: Partial<DTO_META__field_info> = {}) {
    return this.init_as_input(this.create_default__enum(value, enum_object), options_meta);
  }

  /*
   * FIELDS
   */

  /*
   * PROPERTIES
   */

  field_connectable__type() {
    return ENUM__field_connectable_type.STRING_ENUM;
  }

  /*
   * VALUE
   */

  get_value_enum<T extends Record<string, string | number>>(enum_object: T): T[keyof T] {
    let out = this.value;

    assert_type_enum(out, enum_object);

    return out;
  }

  /*
   * VALUE RANGE
   */

  /*
   * VALUES ALLOWED
   */

  /*
   * METHODS
   */

  /*
   * VALIDATION
   */
}
